import { Component, OnInit, Input, trigger, state, style, animate, transition } from '@angular/core';
import { ImgSliderComponent } from '../img-slider.component';

@Component({
  selector: 'app-slider-image',
  templateUrl: './slider-image.component.html',
  styleUrls: ['./slider-image.component.css'],
  animations: [
    trigger('imgState', [
      state('active', style({
        transform: 'translateX(0)',
        visibility: 'visible'
      })),
      state('onLeft', style({
        transform: 'translateX(-100%)',
        visibility: 'hidden'
      })),
      state('onRight', style({
        transform: 'translateX(100%)',
        visibility: 'hidden'
      })),
      transition('onLeft => active', animate('400ms ease-out')),
      transition('onRight => active', animate('400ms ease-out')),
      transition('active => onLeft', animate('400ms ease-out')),
      transition('active => onRight', animate('400ms ease-out')),
      transition('onRight <=> onLeft', animate('0ms'))
    ])
  ]
})
export class SliderImageComponent implements OnInit {
  @Input() imgSrc: string;
  @Input() imgCaption: string;
  @Input() imgState: string;
  @Input() parent: ImgSliderComponent;

  constructor() { }

  ngOnInit() {
  }

  getImageUrl() {
    return 'url(' + this.imgSrc + ')';
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/home/img-slider/slider-image/slider-image.component.ts